import { useTranslations } from 'next-intl'

import { SignUpBenefitsReuse } from '~/components/SlideoutDrawers/AuthPortfolioDialog/AuthSignupDialog'
import { useAuthV2 } from '~/contexts/AuthContext'
import useMabPostHog, {
  PushInteractionLocation,
  PushInteractionType,
  PushWebProduct,
} from '~/hooks/useMabPostHog'
import { AUTH_CONFIG } from '~/pages/api/auth/auth-config'
import { getLocalStorage } from '~/utils/webStorage'

export enum PremiumBannerType {
  articleHeader = 'articleHeader',
  articleFooter = 'articleFooter',
}

const usePremiumContent = () => {
  const { user, showAuthDialog, showVerifyDialog } = useAuthV2()
  const returningUserData = Boolean(getLocalStorage(AUTH_CONFIG.RETURNING_USER))
  const { pushEvent } = useMabPostHog()
  const t = useTranslations('premiumContent')

  let showPremiumPrompt = false

  if (!user || !user.verifiedUser) {
    showPremiumPrompt = true
  }

  const handleSignUpClick = (e: any) => {
    e.preventDefault()
    showAuthDialog(
      '',
      true,
      returningUserData,
      true,
      false,
      () => {
        showVerifyDialog()
      },
      <SignUpBenefitsReuse />
    )
  }

  const handleVerifyClick = (e: any) => {
    e.preventDefault()
    showVerifyDialog()
  }

  const handleClick = (e: any, bannerType: PremiumBannerType) => {
    let type = 'Sign up'
    if (!user) {
      handleSignUpClick(e)
    } else {
      type = 'Verify'
      handleVerifyClick(e)
    }
    const eventName = `Pro article subscription ${type} clicked (${bannerType})`

    pushEvent(eventName, {
      webProduct: PushWebProduct.Articles,
      interactionType: PushInteractionType.Click,
      interactionLocation: PushInteractionLocation.ArticleContent,
    })
  }

  const linkText = !user ? t('signUpForFree') : t('verifyYourAccount')
  const buttonText = !user ? t('createFreeAccount') : t('verifyYourAccount')

  return {
    handleClick,
    linkText,
    showPremiumPrompt,
    buttonText,
  }
}

export default usePremiumContent
